import { MapsTemp } from './map-functions-temp';

export const MapOrderById: Record<MapsTemp, number> = {
  bigApple: 0,
  stackPlaza: 1,
  degenRaceway: 2,
  miamiBeach: 3,
};

// TODO(andrei): add lodash and do sort on this
export const MapOrder: MapsTemp[] = ['bigApple', 'stackPlaza', 'degenRaceway', 'miamiBeach'];
